<template>
  <div id="app" data-app>
    <div class="loading" v-if="organizationData == null || loading">
      <v-progress-circular indeterminate color="#699991" size="64" width="6"></v-progress-circular>
    </div>
    <div v-else>
      <CTSHeader :userData="userData" :organizationData="organizationData" :authClient="ctsAuthClient" />
      <div class="contentSeparator">
        <Navigation :userData="userData" v-bind:navigation="navigation" :organizationData="organizationData"
          v-on:selectItem="selectNav" />
        <ContentPane :userData="userData" :organizationData="organizationData" />
      </div>
    </div>
  </div>
</template>
<!-- <script data-jsd-embedded data-key="bf20fcb6-d841-4a73-972f-bcd851986a4c"
  data-base-url="https://jsd-widget.atlassian.com" src="https://jsd-widget.atlassian.com/assets/embed.js"></script> -->

<script>
import Navigation from "./components/Navigation";
import CTSHeader from "./components/layout/CTSHeader";
import ContentPane from "./components/ContentPane";
import CTSRepository from "./js/CTSRepository.js";
import CtsAuthLibrary from './js/ctsAuthLibrary';
import * as Constants from './js/constants';
import EventBus from "./eventBus";

export default {
  name: "App",
  components: {
    Navigation,
    CTSHeader,
    ContentPane,
  },
  data() {
    return {
      loading: true,
      navigation: [],
      baseNavigation: [
        {
          title: Constants.HOME,
        },
        {
          title: Constants.GATE,
          subNavigationItems: [
            {
              title: Constants.ENTRY_LOG,
            },
            {
              title: Constants.KEYS,
            },
            {
              title: Constants.FREQUENT_VISITORS,
            },
            {
              title: Constants.BLOCKED_LIST,
            },
          ]
        },
        {
          title: Constants.ENFORCEMENT,
          subNavigationItems: [
            {
              title: Constants.INCIDENTS,
            },
            {
              title: Constants.VIOLATIONS,
            }
          ]
        },
        {
          title: Constants.USERS,
          subNavigationItems: [
            {
              title: Constants.UNITS,
            },
            {
              title: Constants.RESIDENT_DIRECTORY,
            },

            {
              title: Constants.VEHICLES,
            },
            // {
            //   title: Constants.PETS,
            // },
            {
              title: Constants.VENDORS,
            }
          ]
        },
        {
          title: Constants.MAINTENANCE,
        },
        // {
        //   title: Constants.EVENTSANDCOMMUNICATIONS,
        //   subNavigationItems: [
        //     {
        //       title: Constants.EVENTS,
        //     },
        //     {
        //       title: Constants.CALENDAR,
        //     }
        //   ]
        // },
        // {
        //   title: Constants.ACCOUNTING,
        // },
        // {
        //   title: Constants.ANALYTICS,
        // },
        {
          title: Constants.SUPPORT,
        },
      ],
      userData: {},
      organizationData: {},
      ctsAuthClient: null,
    };
  },
  watch: {
    organizationData: function () {
      this.loading = false
    }
  },
  created: function () {
    const queryString = window.location.search;
    console.log(queryString);
    const urlParams = new URLSearchParams(queryString);
    const code = urlParams.get("code");
    console.log("Access Code", code);

    var ctsAuthClient = new CtsAuthLibrary();
    this.ctsAuthClient = ctsAuthClient

    ctsAuthClient.authFlow()
      .then(async (data) => {
        let orgStorageKey = "organizationData"
        console.log("Returned Auth Data", data);
        this.userData = data
        await ctsAuthClient.retrieveConfig();

        //Determine if a feature is enabled
        var featureId = "users_modal_admin"
        //var featureId = "home_alert_message"
        if (ctsAuthClient.featureFlags[featureId]) {
          //Feature Code
          console.log("Feature ", featureId, " is enabled")
        }
        else {
          //Disable Feature Code
          console.log("Feature ", featureId, " is not enabled")
          //this.navigation.splice(4, 1);
        }

        console.log("CTS Auth Flow Result", data);
        console.log("CTS Role", ctsAuthClient.userData["custom:cts_role"]);
        EventBus.$on('property-changed', (id) => {
          let savedOrganizationDataJSONString = sessionStorage.getItem(orgStorageKey)
          let savedOrganizationData = JSON.parse(savedOrganizationDataJSONString)
          if (savedOrganizationData != null && savedOrganizationData.organization_id == id) {
            console.log("Cached Organization Data", savedOrganizationData)
            this.organizationData = savedOrganizationData
            this.loading = false

          } else {
            let repository = new CTSRepository({
              organization_id: id
            })
            repository.fetchOrganizationData().then(orgData => {
              console.log("Organization Data", orgData)
              this.organizationData = orgData.data[0]
              let newlyCreatedOrganizationDataMap = orgData.data[0]
              sessionStorage.setItem(orgStorageKey, JSON.stringify(newlyCreatedOrganizationDataMap));
            })
          }
          this.navigation = this.getNavigationBasedOnRole(ctsAuthClient.userData["custom:cts_role"])

        })
        let savedOrganizationDataJSONString = sessionStorage.getItem(orgStorageKey)
        let savedOrganizationData = JSON.parse(savedOrganizationDataJSONString)
        if (savedOrganizationData != null) {
          console.log("Cached Organization Data", savedOrganizationData)
          EventBus.$emit('property-changed', savedOrganizationData.organization_id)
        } else {
          EventBus.$emit('property-changed', this.ctsAuthClient.userData["custom:cts_property_id"].split(":")[0])
        }
      })
      .catch((err) => {
        this.loading = false
        console.log("Error CTS Client", err);
      });
  },
  methods: {
    selectNav(title) {
      var selTitle = title;
      console.log("User selected " + title + " item in directory");
      console.log(selTitle);

      for (var x = 0; x < this.navigation.length; x++) {
        console.log(this.navigation[x]);

        if (this.navigation[x].title !== selTitle) {
          //this.navigation[x].clicked = false;
        } else {
          //this.navigation[x].clicked = true;
        }
      }
    },
    getNavigationBasedOnRole(role) {
      let rbacMap = {
        "ct_admin": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.ACCOUNTING,
          Constants.MAINTENANCE,
          Constants.EVENTSANDCOMMUNICATIONS,
          Constants.ANALYTICS,
          Constants.SUPPORT
        ],
        "admin": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.ACCOUNTING,
          Constants.MAINTENANCE,
          Constants.EVENTSANDCOMMUNICATIONS,
          Constants.ANALYTICS,
          Constants.SUPPORT
        ],
        "property_manager": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.ACCOUNTING,
          Constants.MAINTENANCE,
          Constants.EVENTSANDCOMMUNICATIONS,
        ],
        "hoa_admin": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.ACCOUNTING,
          Constants.MAINTENANCE,
          Constants.EVENTSANDCOMMUNICATIONS,
          Constants.ANALYTICS,
        ],
        "guard": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.ACCOUNTING,
          Constants.MAINTENANCE,
          Constants.EVENTSANDCOMMUNICATIONS,
          Constants.ANALYTICS,
          Constants.SUPPORT
        ],
        "resident": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.USERS,
          Constants.RESIDENT_DIRECTORY,
          Constants.VEHICLES,
          Constants.PETS,
          Constants.VENDORS,
          Constants.UNITS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.VENDORS,
          Constants.MAINTENANCE
        ],
        "secondary_user": [
          Constants.HOME,
          Constants.GATE,
          Constants.ENTRY_LOG,
          Constants.KEYS,
          Constants.FREQUENT_VISITORS,
          Constants.BLOCKED_LIST,
          Constants.ENFORCEMENT,
          Constants.INCIDENTS,
          Constants.VIOLATIONS,
          Constants.VENDORS,
          Constants.MAINTENANCE
        ]
      }
      let finalNavigation = new Array()
      this.baseNavigation.forEach((item) => {
        console.log("Final Navigation", finalNavigation, item)
        if (rbacMap[role].includes(item.title)) {
          let subNavigationItems = item.subNavigationItems
          if (subNavigationItems != null && subNavigationItems != undefined) {
            let newSubNavigationItems = subNavigationItems.filter(subnavItem => rbacMap[role].includes(subnavItem.title))
            if (newSubNavigationItems.length == 0) newSubNavigationItems = null
            console.log("Updated Subnavigation Items", newSubNavigationItems)
            item.subNavigationItems = newSubNavigationItems
          }
          finalNavigation.push(item)
        }
      })
      return finalNavigation

    }
  },
};
</script>


<style src="./css/gatewatch-styles.css"></style>
